<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
export default {
// eslint-disable-next-line vue/multi-word-component-names
  name: "App",
  metaInfo() {
    return {
      title: this.$route.meta.title || 'CAD管理页'
    };
  },
};
</script>
<style lang="scss">
/* 说明：
 * 基础排版、配色、断点等全局规范已收口到 src/styles/global.scss。
 * 桌面/移动共用同一套组件，按窗口宽度自适应（见 src/utils/responsive.js），
 * 因此原先基于 UA 判断跳转到 /Order、/saoyisao、/tishi 的逻辑（路由表中并无这些路径）已移除。
 */
#app {
  min-height: 100vh;
  color: #1f2937;
}
</style>
